import React from 'react';
import './account.scss';

import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Cookies from 'js-cookie';

import colors from '../../util/colors';
import { VERSION, getLogsFlag, setLogsFlag, fireAnalytics } from '../../pages/utils';

// Actions
import { deleteDevice } from '../../store/actions/deviceActions';
import { clearFeaturedPlaylist, clearUserPlaylists, clearActivePlaylist } from '../../store/actions/playlistActions';
import { clearUser } from '../../store/actions/userActions';
import { clearSubscription } from '../../store/actions/subscriptionActions';
import { DELETE_DEVICE_SUCCESS } from '../../store/constants/deviceConstants';

import { LEFT, RIGHT, BACK, ENTER } from '../../util/remoteButtons';

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: getLogsFlag(),
      logsTextVisibilty: false,
      clearCache: false,
      selectedBtn: 'close',
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'close';
    this.enableLogs = 0;
    this.logsTimeout = null;
    this.logsText = '';
    this.acc = React.createRef();
  }
  componentDidMount() {
    fireAnalytics('Page', 'Account Page Loaded');
    setTimeout(() => {
      this.acc.current.focus();
    }, 300);
  }

  handleKeyDown(e) {
    e.stopPropagation();
    if (e.which === 38 || e.which === 40) {
      if (this.logsTimeout !== null) {
        clearTimeout(this.logsTimeout);
      }
      if (this.enableLogs === 76 && e.which !== 40) this.enableLogs = 0;
      this.enableLogs = this.enableLogs + e.which;
      if (this.enableLogs === 154) {
        if (this.state.logs) {
          this.logsText = 'Player Logs Disabled';
          this.setState({ logsTextVisibilty: true });
          setTimeout(() => {
            this.setState({ logsTextVisibilty: false });
          }, 3000);
          setLogsFlag(false);
          this.setState({ logs: false });
        } else {
          setLogsFlag(true);
          this.setState({ logs: true });
          this.logsText = 'Player Logs Enabled';
          this.setState({ logsTextVisibilty: true });
          setTimeout(() => {
            this.setState({ logsTextVisibilty: false });
          }, 3000);
        }
        this.enableLogs = 0;
      }
      this.logsTimeout = setTimeout(() => {
        this.enableLogs = 0;
      }, 7000);
    } else {
      this.enableLogs = 0;
    }
    switch (e.which) {
      case RIGHT:
        if (this.state.clearCache) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          this.refs.yes.focus();
          this.selectedBtn = 'Yes';
        } else {
          if (this.state.selectedBtn === 'logout') {
            this.setState({ selectedBtn: 'close' });
          } else if (this.state.selectedBtn === 'close') {
            this.setState({ selectedBtn: 'clear' });
          }
        }
        break;
      case LEFT:
        if (this.state.clearCache) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          this.refs.no.focus();
          this.selectedBtn = 'No';
        } else {
          if (this.state.selectedBtn === 'close') {
            this.setState({ selectedBtn: 'logout' });
          } else if (this.state.selectedBtn === 'clear') {
            this.setState({ selectedBtn: 'close' });
          }
        }
        break;
      case ENTER:
        if (this.state.clearCache) {
          if (this.selectedBtn === 'No') {
            this.setState({ clearCache: false });
            setTimeout(() => {
              this.refs.clear.focus();
              this.selectedBtn = 'Clear';
            }, 200);
          }
          if (this.selectedBtn === 'Yes') {
            // window.open("", "_self").close();
            // this.props.history.push('/');
            this.removeAllDownloads();
          }
        } else {
          if (this.state.selectedBtn === 'close') {
            this.props.onClose();
          } else if (this.state.selectedBtn === 'logout') {
            fireAnalytics('User', 'Logged Out', this.props.user.data.user?.email);
            this.logout();
          } else if (this.state.selectedBtn === 'clear') {
            this.removeAllDownloads();
          }
        }
        break;
      case 27: /////////////////For Esc Keyboard Key
      case BACK:
        this.props.onClose();
        break;
    }
  }

  removeAllDownloads() {
    const that = this;
    var successCb = function (cbObject) {
      that.setState({ clearCache: false });
      that.props.history.push('/');
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
    };

    var options = {
      device: 'internal', // This will remove all the files in the local storage.
    };

    var storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }

  logout = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.props.history.push('/');
      }
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      localStorage.removeItem('DeviceID');
      Cookies.remove('auth__token');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
    } catch (e) {
      // console.log(e);
    }
  };

  render() {
    return (
      <div
        className="account"
        style={{
          height: window.innerWidth <= window.innerHeight ? '50%' : '88%',
        }}
        ref={this.acc}
        onKeyDown={this.handleKeyDown}
        tabIndex={9}
      >
        <h3 className="account__header">Account</h3>

        <div className="account__info">
          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">User:</div>
            <div className="account__info__wrapper__text2">{this.props.user.data.user?.email}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Device ID:</div>
            <div className="account__info__wrapper__text2">{this.props.app.SCAPDeviceId}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Device Name:</div>
            <div className="account__info__wrapper__text2">{this.props.device.data.name}</div>
          </div>

          <div className="account__info__wrapper">
            <div className="account__info__wrapper__text1">Subscription:</div>
            <div className="account__info__wrapper__text2">{this.props.subscription.data.plan?.description}</div>
          </div>

          <div className="pair__box__container__qrcode" style={{ position: 'absolute', right: '12%', top: '20%' }}>
            <QRCode className="" value={this.props.app.SCAPDeviceId} size={180} renderAs="svg" />
            <img className="pair__box__container__qrcode__logo" src="assets/img/red-logo.svg" alt="" />
          </div>
        </div>

        <div className="account__btns">
          <button
            tabIndex="7"
            style={this.state.selectedBtn === 'logout' ? { border: '6px solid #910048' } : null}
            className="account__btns__btn"
          >
            Logout
          </button>
          <button
            tabIndex="6"
            style={this.state.selectedBtn === 'close' ? { border: '6px solid #910048' } : null}
            className="account__btns__btn"
          >
            Close
          </button>
          <button
            tabIndex="6"
            style={this.state.selectedBtn === 'clear' ? { border: '6px solid #910048' } : null}
            className="account__btns__btn"
          >
            Clear Cache
          </button>
        </div>

        <div
          className="account__footer"
          style={{
            height: window.innerWidth <= window.innerHeight ? '120px' : '95px',
            fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.5rem',
          }}
        >
          For help contact: <strong>support@blackdove.com</strong>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});

export default connect((state) => {
  const { app, activePlaylist, device, user, subscription } = state;
  return {
    app,
    device,
    user,
    subscription,
    activePlaylist,
  };
}, mapDispatchToProps)(Account);
